<form
    id="digitalPlanPrintModalForm"
    name="digitalPlanPrintModalForm"
    novalidate
    autocomplete="off"
    #digitalPlanPrintModalForm="ngForm">
    <div class="modal fade in">
        <div class="backdrop"></div>
        <div
            class="modal-dialog"
            [class]="modalSize">
            <div class="modal-content nlr-busy-modal">
                <div class="modal-header">
                    <button
                        type="button"
                        (click)="closeDialog()"
                        title="Close"
                        class="close">
                        <i class="nlrp-icon nlrp-icon-close"></i>
                    </button>
                    <h4 class="modal-title">{{title}}</h4>
                </div>
                @if (showWatermark() || errorText) {
                    <div class="modal-body">
                        <div>
                            @if (showWatermark()) {
                                <label class="control-label">Watermark</label>
                                <div
                                    class="input-group"
                                    [ngClass]="{'has-error': watermark | formFieldHasError}">
                                    <textarea
                                        class="form-control"
                                        name="watermark"
                                        placeholder="Enter watermark"
                                        rows="3"
                                        cols="40"
                                        [maxlength]="getMaxWatermarkCharacters()"
                                        [nlrPattern]="watermarkRegex"
                                        [ngModel]="watermarkText"
                                        (ngModelChange)="onChangeWatermarkText($event)"
                                        #watermark="ngModel">
                                    </textarea>
                                </div>
                                @if (watermark.valid) {
                                    <p class="text-right">
                                        <span>{{getWatermarkCharactersRemaining() + ' characters remaining'}}</span>
                                    </p>
                                }
                                @if (watermark | formFieldHasError) {
                                    <div class="alert alert-danger">PDF watermark text is not valid.</div>
                                }
                            }
                            @if (errorText) {
                                <div class="alert alert-danger">{{errorText}}</div>
                            }
                        </div>
                    </div>
                }
                <div class="modal-footer">
                    <button
                        id="printPdf"
                        type="button"
                        class="btn btn-default nlr-btn-sm"
                        title="Print"
                        (click)="print()"
                        [disabled]="digitalPlanPrintModalForm.invalid">
                        Print
                    </button>
                    <button
                        id="closePdfSettings"
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        title="Close"
                        (click)="closeDialog()">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>
